export const DISMISSED_ANNOUNCEMENTS_KEY = "announcement_dismissed";

export function getDismissedAnnouncementIds() {
  if (typeof window === "undefined") {
    return [];
  }
  try {
    const raw = window.localStorage.getItem(DISMISSED_ANNOUNCEMENTS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function isAnnouncementDismissed(id) {
  return getDismissedAnnouncementIds().includes(id);
}

export function dismissAnnouncement(id) {
  if (typeof window === "undefined" || !id) {
    return;
  }
  const ids = getDismissedAnnouncementIds();
  if (!ids.includes(id)) {
    ids.push(id);
    window.localStorage.setItem(
      DISMISSED_ANNOUNCEMENTS_KEY,
      JSON.stringify(ids)
    );
  }
}